// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Priorities_GetResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * Response contract for GET /so/priorities/get/{id}
 *
 * A single `so_priorities` record. The `so_priority_created_at` datetime
 * is converted to ISO 8601 UTC by the controller before emission.
 */
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export interface Priorities_GetResponseDados {
so_priority_id?: number
so_priority_name?: string
so_priority_franchise_id?: number
so_priority_active?: number
so_priority_color?: string
so_priority_created_at?: string
}

export type Priorities_GetResponse = ApiResponse<Priorities_GetResponseDados>;

registerResponseContract('Priorities_GetResponse', {
  so_priority_id:           { type: 'number',  required: false },
  so_priority_name:         { type: 'string',  required: false },
  so_priority_franchise_id: { type: 'number',  required: false },
  so_priority_active:       { type: 'number',  required: false },
  so_priority_color:        { type: 'string',  required: false },
  so_priority_created_at:   { type: 'string',  required: false },
})
